import { Component } from '@angular/core';

@Component({
  selector: 'app-p-pdp',
  templateUrl: './p-pdp.component.html',
  styleUrls: ['./p-pdp.component.scss']
})
export class PPdpComponent {

}
